import React, { useState, useEffect } from "react";
import Layout from "../../../components/Admin/Layout";
import Subtitle from "../../../components/Admin/Subtitle";
import Loading from "../../../components/shared/Loading";
import Search from "../../../components/shared/Search";
import CustomizedBtn from "../../../components/Admin/CustomizedBtn";
import Item from "../../../components/Admin/Item";
import "./Operators.scss";
import ModalForm from "../../../components/Admin/ModalForm";
import SimpleModal from "../../../components/shared/MessageModal";
import helperAdmin from "../../../utils/helperAdmin";
import AdminService from "../../../services/AdminServices";
import { FormControlLabel, Switch } from "@material-ui/core";
import { ReactComponent as InfoIcon } from "../../../../assets/images/info_red.svg";
import moment from "moment";

function Operators() {
  const [searchText, setSearchText] = useState('')
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openModalForm, setModalForm] = useState(false);
  const [openMessage, setOpenMessage] = useState(false);
  const [error, setError] = useState({});
  const [operator, setOperator] = useState({
    name: "",
    image: "",
    openingTime: null,
    closingTime: null,
    leadTime: "",
    isIntegrated: false,
  });

  const formatOperators = async (operators) => {
    const [date] = new Date().toISOString().split('T')

    const format = operators.map( data => ({ 
      ...data,
      closingTime: data.closingTime ?  moment(`${date} ${data.closingTime}`) : moment(), 
      openingTime: data.openingTime ? moment(`${date} ${data.openingTime}`) : moment()
    }))

    return format
  }

  const fetchOperatorsByName = async (name) => {
    setLoading(true);
    const format = await AdminService.getOperatorsByName(name)
      .then((operators) => formatOperators(operators))

    setData(format);
    setLoading(false);
  };

  const fetchAllOperators = async () => {
    setLoading(true);
    const format = await AdminService.getOperators()
      .then((operators) => formatOperators(operators))
    
    setData(format);
    setLoading(false);
  };

  const renderItems = () => {
    return data.map((d) => (
      <Item
        key={d.id}
        onClickEdit={() => {
          setModalForm(true);
          setOperator(d);
          console.log({d})
        }}
        onClickDelete={() => {
          setOpenMessage(true);
          setOperator(d);
        }}
      >
        <div className="operator-item">
          <img src={d.image} alt="logo" />
          <p>{d.name}</p>
        </div>
      </Item>
    ));
  };

  const clearOperator = () => {
    setOperator({
      name: "",
      image: null,
      openingTime: "",
      closingTime: "",
      leadTime: "",
    });
    setError({});
  };

  const handleChange = (evt, name) => {
    let newOperator = { ...operator };
    let value = evt?.target ? evt?.target.value : evt;
    const key = evt?.target ? evt?.target.name : name;
    setOperator({ ...newOperator, [key]: value });
    let newError = { ...error };
    if (newError[key]) newError = helperAdmin.removeKey(key, newError);
    setError(newError);
  };

  const handleCreateOperator = async () => {
    setLoading(true);
    // Validar si campos vacios
    const newError = helperAdmin.validateOperator(operator);
    setError(newError);
    // RETORNAR para parar la ejecucion
    if (
      Object.entries(newError).length !== 0 &&
      newError.constructor === Object
    )
      return setLoading(false);
    try {
      operator.closingTime = moment(operator.closingTime).format('HH:mm:ss')
      operator.openingTime = moment(operator.openingTime).format('HH:mm:ss')

      if (operator.id) await AdminService.updateOperator(operator);
      else await AdminService.createOperator(operator);
      clearOperator();
      setModalForm(false);
      setLoading(false);
      await fetchAllOperators();
    } catch (error) {
      setLoading(false);

      console.error(error);
    }
  };

  const handleDelete = async () => {
    const response = await AdminService.deleteOperator(operator.id);
    console.log(response);
    await fetchAllOperators();
    clearOperator();
    setOpenMessage(false);
  };

  useEffect(() => {
    fetchAllOperators();
  }, []);

  return (
    <Layout>
      <ModalForm
        title="Partners"
        visible={openModalForm}
        closeModal={() => {
          setModalForm(false);
          clearOperator();
        }}
        onClickBtn1={() => {
          setModalForm(false);
          clearOperator();
        }}
        onClickBtn2={handleCreateOperator}
        updating={operator.id}
        name={operator.name}
        image={operator.image}
        openingTime={operator.openingTime}
        closingTime={operator.closingTime}
        leadTime={operator.leadTime}
        onChange={handleChange}
        error={error}
        floatingLabels
      >
        <div className="operator-indication">
          <div className="operator-indication-icon">
            <InfoIcon />
          </div>
          <div className="operator-indication-text">
            Los cambios realizados en la fecha de expiración solo afectaran a
            los nuevos pedidos que se registren en Agente R, no será
            retroactivo.
          </div>
        </div>
        <div className="operator-integration">
          <div className="operator-integration-title">
            Partners con integración
          </div>
          <div className="operator-integration-switch">
            <Switch
              color="primary"
              checked={operator.isIntegrated}
              onChange={() => setOperator({ ...operator, isIntegrated: !operator.isIntegrated })}
            />
          </div>
        </div>
      </ModalForm>

      <SimpleModal
        visible={openMessage}
        closeModal={() => {
          setOpenMessage(false);
          clearOperator();
        }}
        message="¿Desea eliminar el operador seleccionado?"
        type={3}
        txtBtn1="Cancelar"
        txtBtn2="Eliminar"
        onClickBtn1={() => {
          setOpenMessage(false);
          clearOperator();
        }}
        onClickBtn2={handleDelete}
      />
      <Loading visible={loading} />
      <div className="operators-container">
        <Subtitle
          text="Operadores de retiro"
          onClick={() => {
            setModalForm(true);
          }}
        />
        <div className="operators-items">
          <div className="search-box">
            <div className="search-input">
              <Search
                text={searchText}
                placeholder="Buscar..."
                setText={e => setSearchText(e.target.value)}
                onEnter={() => fetchOperatorsByName(searchText)}
              />
            </div>
            <CustomizedBtn margin="0" outline={false} filled onClick={() => fetchOperatorsByName(searchText)}>Buscar</CustomizedBtn>
            <CustomizedBtn
              margin="0"
              onClick={() => {
                setSearchText('')
                fetchAllOperators()
              }}
            >
              Limpiar
            </CustomizedBtn>
          </div>
          {data.length !== 0 ? renderItems() : <p className="empty-text">No hay datos</p>}
        </div>
      </div>
    </Layout>
  );
}

export default Operators;
